module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Immovables","newAsset":"+ Add new"},"et":{"title":"Immovables","newAsset":"+ Add new"},"ru":{"title":"Immovables","newAsset":"+ Add new"}}')
  delete Component.options._Ctor
}
